// extracted by mini-css-extract-plugin
module.exports = {"Page404":"Page404_Page404__1xAfr","wrapper":"Page404_wrapper__1iKD9","description":"Page404_description__3CmiV"};